import { render } from "./ServiceDetails5.vue?vue&type=template&id=4f3d3c59&scoped=true"
import script from "./ServiceDetails5.vue?vue&type=script&lang=js"
export * from "./ServiceDetails5.vue?vue&type=script&lang=js"

import "./ServiceDetails5.vue?vue&type=style&index=0&id=4f3d3c59&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3d3c59"]])

export default __exports__